// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"850":"293b02e9","987":"9f70dcca"}[chunkId] + ".js";
};